module.exports = __webpack_public_path__ + "img/1970East-066_WEB-min.b69f7406.jpg";